"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChooseAccount;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _ChooseAccount = require("./ChooseAccount.styles");
var _ConfirmAccount = _interopRequireDefault(require("../ConfirmAccount/ConfirmAccount"));
var _SingleAccount = _interopRequireDefault(require("../SingleAccount/SingleAccount"));
var _UnsupportedAccounts = _interopRequireDefault(require("../UnsupportedAccounts/UnsupportedAccounts"));
var _ReselectAccount = _interopRequireDefault(require("../ReselectAccount/ReselectAccount"));
var _constants = require("../../constants");
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */

function ChooseAccount(_ref) {
  var changeBank = _ref.changeBank,
    headerText = _ref.headerText,
    supportedAccounts = _ref.supportedAccounts,
    unsupportedAccounts = _ref.unsupportedAccounts,
    selectedAccount = _ref.selectedAccount,
    onAccountChange = _ref.onAccountChange,
    unsupportedAccountDisclaimer = _ref.unsupportedAccountDisclaimer,
    changeBankLabel = _ref.changeBankLabel,
    changeBankAnchor = _ref.changeBankAnchor;
  var classes = (0, _ChooseAccount.useStyles)();
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.Container, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-testid": "choose-container"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: classes.title2,
    "data-testid": "container-header-text"
  }, headerText), supportedAccounts && supportedAccounts.length === 1 && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper,
    "data-testid": "single-account-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_SingleAccount["default"], {
    bankAccount: supportedAccounts[0]
  })), supportedAccounts && supportedAccounts.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper,
    "data-testid": "multiple-account-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_ConfirmAccount["default"], {
    accounts: supportedAccounts,
    selectedAccount: selectedAccount,
    handleSelection: onAccountChange
  })), unsupportedAccounts && unsupportedAccounts.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapper,
    "data-testid": "unsupported-account-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_UnsupportedAccounts["default"], {
    accounts: unsupportedAccounts,
    disclaimer: unsupportedAccountDisclaimer
  })), changeBank && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapperChangeBank,
    "data-testid": "reselect-bank-wrap"
  }, /*#__PURE__*/_react["default"].createElement(_ReselectAccount["default"], {
    onChangeBank: changeBank,
    labelText: changeBankLabel,
    anchorText: changeBankAnchor
  }))));
}
ChooseAccount.propTypes = {
  /**
   * collection of accounts supported for ACH transfers
   */
  supportedAccounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })),
  /**
   * collection of accounts NOT supported for ACH transfers
   */
  unsupportedAccounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })),
  /**
   * custom text to be displayed as the header of the component
   */
  headerText: _propTypes.string,
  /**
   * an object representing the currently selected account
   */
  selectedAccount: (0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  }),
  /**
   * a url used to redirect back to the bank selection page
   */
  changeBank: _propTypes.func.isRequired,
  /**
   * custom text in label to be displayed in change bank option,
   * if is empty default text will be displayed
   */
  changeBankLabel: _propTypes.string,
  /**
   * custom text in button to be displayed in change bank option,
   * if is empty default text will be displayed
   */
  changeBankAnchor: _propTypes.string,
  /**
   * an onChange event handler
   */
  onAccountChange: _propTypes.func,
  /**
   * custom text to be displayed as disclaimer for unsupported account,
   * if is empty default text will be displayed
   */
  unsupportedAccountDisclaimer: _propTypes.string
};

/* istanbul ignore next */
ChooseAccount.defaultProps = {
  headerText: _constants.CHOOSE_CONTAINER_TITLE,
  onAccountChange: function onAccountChange() {},
  supportedAccounts: [],
  unsupportedAccounts: [],
  selectedAccount: {},
  unsupportedAccountDisclaimer: _constants.UNSUPPORTED_ACCOUNTS_DISCLAIMER,
  changeBankLabel: _constants.RESELECT_DIFFERENT_BANK_LABEL,
  changeBankAnchor: _constants.RESELECT_DIFFERENT_BANK_ANCHOR
};
